import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Pages } from 'src/app/models/menu.model';
import { Session } from 'src/app/models/session.model';
import { AuthService } from 'src/app/services/auth.service';
import { HeaderComponent } from '../header/header.component';
import { IonAccordion, IonAccordionGroup, IonContent, IonItem, IonLabel, IonMenuToggle, IonRouterLink } from '@ionic/angular';
import { HeroComponent } from './hero/hero.component';

import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, IonAccordion, IonAccordionGroup, IonContent, IonItem, IonLabel, IonMenuToggle, HeroComponent, RouterLinkActive, RouterLink, IonRouterLink]
})
export class SidebarComponent {
  private auth = inject(AuthService);

  public appPages = Pages;
  data: Session

  constructor() {
    this.auth.getCredentials().then(async (data: Session) => {
      this.data = data;
    });
  }

  showItem(child: any){
    if (this.data && child.url == '/degree-progress' && (this.data.userData['id_institution'] == null || this.data.userData['id_institution'] == undefined)){
      return false;
    } 
    return true;
  }

  toggleAccordion(event: KeyboardEvent, p: any) {
    const target = event.target as HTMLElement;
    const accordion = target.closest('ion-accordion');
    if (accordion) {
      accordion.toggleAttribute('expanded'); // Cambia el estado expandido
    }
  }
  
}
